import { type ReactElement, type ReactNode } from 'react';
import clsx from 'clsx';
import { NotAvailable } from '../../NotAvailable';
import styles from './style.module.scss';

interface MetricProperties {
  readonly id: string;
  readonly value?: string | number | null;
  readonly displayValue?: ReactNode;
  readonly unit?: string;
  readonly mutedUnit?: boolean;
  readonly rightAligned?: boolean;
  readonly digits?: number;
  readonly tooltip: string;
  readonly attention?: boolean;
  readonly unavailable?: boolean;
}

export const OperationalMetric = ({
  id,
  value,
  displayValue,
  unit,
  mutedUnit = true,
  rightAligned = false,
  digits = 0,
  tooltip,
  attention = false,
  unavailable = false,
}: MetricProperties): ReactElement => {
  const missing = value === undefined || value === null;
  let text: string | null | undefined = unavailable ? 'Not available' : 'N/A';
  if (!missing) text = typeof value === 'number' ? value.toFixed(digits) : value;
  const suffix = !missing && unit ? ` ${unit}` : '';
  return (
    <span
      id={id}
      className={clsx(styles.metric, {
        [styles['right-aligned']]: rightAligned,
        'tds-text-warning': attention && !missing,
      })}
      aria-label={`${text}${suffix}. ${tooltip}`}
    >
      {missing ? <NotAvailable label={unavailable ? 'Not available' : 'N/A'} /> : (displayValue ?? text)}
      {!missing && unit && (
        <>
          {' '}
          <span className={mutedUnit && !attention ? 'tds-text-grey-350' : undefined}>{unit}</span>
        </>
      )}
    </span>
  );
};
